import React from 'react'
import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'

export function WarningBanner() {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())

  return (
    <div className="idle-timer-banner warning">
      <div className="inner">
        <p className="heading">{t('Still playing?')}</p>
        <p>{t('You haven’t placed a bet in a while. The stream will pause soon unless you place a bet.')}</p>
      </div>
    </div>
  )
}
